import React,{ useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { doc, getDoc } from 'firebase/firestore';
import { db, logMe } from '../../firebase';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';

function Success() {

    const [purchase, setPurchase] = useState();
    const {id} = useParams();

    useEffect(() => {
        // get purchase info
        const purchaseRef = doc(db, `ticketPurchases/${id}`)
        logMe('success', {id});
        getDoc(purchaseRef).then((doc) => {
            if (doc.exists()) {
                const data = doc.data()
                console.log("Document data:", data);
                setPurchase(data)
                window.fbq('track', 'Purchase', {currency: "AUD", value: data.amountCents});
                // store user id inside of local storage
                // BUG WITH IFRAME
                // localStorage.setItem('userId', data.userId);
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        });
    }, []);

    return (
        <Container maxWidth="sm" style={{textAlign: 'center'}}>
            <h1> {purchase?.user.firstName} You're going to House Down Under!</h1>
            <p>You will receive your tickets shortly to the following email:</p>
            <h2>{ purchase?.user.email}</h2>
            <p>Didn't receive the email?</p>
            <Link to={`/edit-user-data/`+ purchase?.userId}>
                Click here to make changes
            </Link>
        </Container>
    );
}

export default Success;